import { useNavigate } from "react-router-dom";
import { Truck, Disc3, Wrench, ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const OPTIONS = [
  {
    name: "PKW-Anhänger (750 kg)",
    sub: "Wahlweise offen oder mit Plane",
    href: "/anhaenger",
    icon: Truck,
  },
  {
    name: "Parkett Poliermaschine",
    sub: "Zum Reinigen, Ölen & Polieren von Holzböden",
    href: "/geraete/parkett-poliermaschine",
    icon: Disc3,
  },
  {
    name: "Wand- & Deckenschleifer",
    sub: "Schleifgiraffe für Trockenbau & Renovierung",
    href: "/geraete/wandschleifer",
    icon: Wrench,
  },
];

export default function RentPickerModal({ open, onOpenChange }) {
  const navigate = useNavigate();

  const handleSelect = (href) => {
    onOpenChange(false);
    navigate(href);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl p-6 sm:p-8" data-testid="rent-picker-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-zinc-950">
            Was möchtest du mieten?
          </DialogTitle>
          <DialogDescription className="text-zinc-500">
            Wähle dein gewünschtes Mietobjekt aus.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-2">
          {OPTIONS.map((opt) => (
            <button
              key={opt.href}
              type="button"
              onClick={() => handleSelect(opt.href)}
              data-testid={`rent-picker-option-${opt.href.split("/").pop()}`}
              className="group w-full flex items-center gap-4 p-4 rounded-xl border border-zinc-200 bg-white text-left hover:border-orange-500 hover:bg-orange-50 transition-all duration-200"
            >
              <div className="w-12 h-12 rounded-xl bg-orange-100 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-600 transition-colors">
                <opt.icon className="h-6 w-6 text-orange-600 group-hover:text-white transition-colors" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-zinc-900">{opt.name}</p>
                <p className="text-sm text-zinc-500">{opt.sub}</p>
              </div>
              <ArrowRight className="h-5 w-5 text-zinc-300 group-hover:text-orange-600 group-hover:translate-x-1 transition-all flex-shrink-0" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
